import { Button, Modal } from 'antd';
import SuccessSvg from '@/assets/icons/success.svg?url';
import ErrorSvg from '@/assets/icons/error.svg?url';
import { ExclamationCircleOutlined, ExclamationOutlined, WarningOutlined, ReloadOutlined } from '@ant-design/icons';
import './ModalAlert.scss';
import { useMemo } from 'react';
const titles = {
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
};

const icons = {
  success: SuccessSvg,
  error: ErrorSvg,
  warning: <WarningOutlined style={{ fontSize: '32px', color: 'orange' }} />,
};

const colors = {
  success: 'green',
  error: '#023E65',
  warning: 'orange',
  primary: '#023E65',
};

function ModalAlert({ show, title, message, onClose, type = 'success', okText = 'Try again', refresh = false }) {
  const titleText = useMemo(() => title || titles[type], [title, type]);
  const iconToShow = useMemo(() => icons[type], [type]);

  return (
    <Modal
      className="modal-alert"
      open={show}
      onCancel={onClose}
      footer={null}
      centered
      zIndex="9999"
      width={384}
    >
     <div className="modal-alert-card">
				<div className="modal-alert-header">
					<div className="modal-alert-header-content">
						<div className="modal-alert-icon-title">
							<div className="modal-alert-icon">
								{type === 'warning' ? (
									iconToShow
								) : (
									<div className="icon-container">
										<ExclamationCircleOutlined style={{ fontSize: '16px' }} />
									</div>
								)}
							</div>
							<div className="modal-alert-title-section">
								<div className="modal-alert-title">{titleText}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-alert-body">
					<div className="modal-alert-message">
						<span className="message-text">
							{message ||
								`Sorry for the disruption—an unexpected error occurred on our side. 
								We've logged the details and our team is investigating. 
								Please try refreshing the page; if it continues, please contact us at `}
						</span>
						<span className="support-email"> support@hydrodigital.com</span>
					</div>
					<div className="modal-alert-actions align-items-center">
						<Button
							type="primary"
							style={{ backgroundColor: colors[type], borderColor: colors[type] }}
							onClick={() => refresh ? window.location.href = '/' : onClose() }
						>
              <ReloadOutlined style={{ marginRight: '8px' }} />
							{okText}
						</Button>
					</div>
				</div>
			</div>
    </Modal>
  );
}

export default ModalAlert;
